/**
 * Flags de session OnTime utilisés pour distinguer un utilisateur réellement
 * connecté (login email ou login par code agent) d'un device pointeuse
 * uniquement authentifié pour scanner des codes.
 *
 * AuthGuard / GuestGuard / LayoutClockings consomment ces flags pour décider
 * quel home page afficher et quel layout monter.
 */

const EMAIL_LOGIN_FLAG = 'ontime_email_login';
const CODE_LOGIN_FLAG = 'ontime_code_login';

export const ONTIME_LOGIN_FLAGS = [EMAIL_LOGIN_FLAG, CODE_LOGIN_FLAG] as const;

/** True si l'utilisateur OnTime est connecté (par email OU par code agent). */
export const isOnTimeUserLogin = (): boolean =>
  !!sessionStorage.getItem(EMAIL_LOGIN_FLAG) || !!sessionStorage.getItem(CODE_LOGIN_FLAG);

/** Pose le flag de login par code agent. À appeler après un loginByCode réussi. */
export const setOnTimeCodeLoginFlag = (): void => {
  sessionStorage.setItem(CODE_LOGIN_FLAG, '1');
};

/** Retire tous les flags de session OnTime — à appeler au logout. */
export const clearOnTimeLoginFlags = (): void => {
  sessionStorage.removeItem(EMAIL_LOGIN_FLAG);
  sessionStorage.removeItem(CODE_LOGIN_FLAG);
};
